var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5113 0.952499H2.4812C1.37844 0.952499 0.476183 1.87783 0.476183 3.00877V17.4027H2.4812V3.00877H14.5113V0.952499ZM17.5189 5.06506H6.49121C5.38846 5.06506 4.48621 5.99037 4.48621 7.12133V21.5153C4.48621 22.6463 5.38846 23.5716 6.49121 23.5716H17.5189C18.6216 23.5716 19.5239 22.6463 19.5239 21.5153V7.12133C19.5239 5.99037 18.6216 5.06506 17.5189 5.06506ZM17.5189 21.5153H6.49121V7.12133H17.5189V21.5153Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.40ad6c1cb5388247ad015d24e71b24ea.svg";
export { ForwardRef as ReactComponent };